// extracted by mini-css-extract-plugin
export default {"tooltip":"HelpTip_tooltip__LcC6f","icon":"HelpTip_icon__sI-8V"};